export default {
    'afghanistan': {
        'uk_name': 'Афганістан',
        'ru_name': 'Афганистан',
        'en_name': 'Afghanistan',
        'alpha_2': 'AF',
        'alpha_3': 'AFG',
    },
    'alandislands': {
        'uk_name': 'Аландські острови',
        'ru_name': 'Аландские Острова',
        'en_name': 'Åland Islands',
        'alpha_2': 'AX',
        'alpha_3': 'ALA',
    },
    'albania': {
        'uk_name': 'Албанія',
        'ru_name': 'Албания',
        'en_name': 'Albania',
        'alpha_2': 'AL',
        'alpha_3': 'ALB',
    },
    'algeria': {
        'uk_name': 'Алжир',
        'ru_name': 'Алжир',
        'en_name': 'Algeria',
        'alpha_2': 'DZ',
        'alpha_3': 'DZA',
    },
    'americansamoa': {
        'uk_name': 'Американське Самоа',
        'ru_name': 'Американское Самоа',
        'en_name': 'American Samoa',
        'alpha_2': 'AS',
        'alpha_3': 'ASM',
    },
    'andorra': {
        'uk_name': 'Андорра',
        'ru_name': 'Андорра',
        'en_name': 'Andorra',
        'alpha_2': 'AD',
        'alpha_3': 'AND',
    },
    'angola': {
        'uk_name': 'Ангола',
        'ru_name': 'Ангола',
        'en_name': 'Angola',
        'alpha_2': 'AO',
        'alpha_3': 'AGO',
    },
    'anguilla': {
        'uk_name': 'Ангілья',
        'ru_name': 'Ангилья',
        'en_name': 'Anguilla',
        'alpha_2': 'AI',
        'alpha_3': 'AIA',
    },
    'antiguaandbarbuda': {
        'uk_name': 'Антигуа і Барбуда',
        'ru_name': 'Антигуа и Барбуда',
        'en_name': 'Antigua and Barbuda',
        'alpha_2': 'AG',
        'alpha_3': 'ATG',
    },
    'argentina': {
        'uk_name': 'Аргентина',
        'ru_name': 'Аргентина',
        'en_name': 'Argentina',
        'alpha_2': 'AR',
        'alpha_3': 'ARG',
    },
    'armenia': {
        'uk_name': 'Вірменія',
        'ru_name': 'Армения',
        'en_name': 'Armenia',
        'alpha_2': 'AM',
        'alpha_3': 'ARM',
    },
    'aruba': {
        'uk_name': 'Аруба',
        'ru_name': 'Аруба',
        'en_name': 'Aruba',
        'alpha_2': 'AW',
        'alpha_3': 'ABW',
    },
    'australia': {
        'uk_name': 'Австралія',
        'ru_name': 'Австралия',
        'en_name': 'Australia',
        'alpha_2': 'AU',
        'alpha_3': 'AUS',
    },
    'austria': {
        'uk_name': 'Австрія',
        'ru_name': 'Австрия',
        'en_name': 'Austria',
        'alpha_2': 'AT',
        'alpha_3': 'AUT',
    },
    'azerbaijan': {
        'uk_name': 'Азербайджан',
        'ru_name': 'Азербайджан',
        'en_name': 'Azerbaijan',
        'alpha_2': 'AZ',
        'alpha_3': 'AZE',
    },
    'thebahamas': {
        'uk_name': 'Багамські Острови',
        'ru_name': 'Багамские Острова',
        'en_name': 'The Bahamas',
        'alpha_2': 'BS',
        'alpha_3': 'BHS',
    },
    'bahrain': {
        'uk_name': 'Бахрейн',
        'ru_name': 'Бахрейн',
        'en_name': 'Bahrain',
        'alpha_2': 'BH',
        'alpha_3': 'BHR',
    },
    'bangladesh': {
        'uk_name': 'Бангладеш',
        'ru_name': 'Бангладеш',
        'en_name': 'Bangladesh',
        'alpha_2': 'BD',
        'alpha_3': 'BGD',
    },
    'barbados': {
        'uk_name': 'Барбадос',
        'ru_name': 'Барбадос',
        'en_name': 'Barbados',
        'alpha_2': 'BB',
        'alpha_3': 'BRB',
    },
    'belarus': {
        'uk_name': 'Білорусь',
        'ru_name': 'Беларусь',
        'en_name': 'Belarus',
        'alpha_2': 'BY',
        'alpha_3': 'BLR',
    },
    'belgium': {
        'uk_name': 'Бельгія',
        'ru_name': 'Бельгия',
        'en_name': 'Belgium',
        'alpha_2': 'BE',
        'alpha_3': 'BEL',
    },
    'belize': {
        'uk_name': 'Беліз',
        'ru_name': 'Белиз',
        'en_name': 'Belize',
        'alpha_2': 'BZ',
        'alpha_3': 'BLZ',
    },
    'benin': {
        'uk_name': 'Бенін',
        'ru_name': 'Бенин',
        'en_name': 'Benin',
        'alpha_2': 'BJ',
        'alpha_3': 'BEN',
    },
    'bermuda': {
        'uk_name': 'Бермудські Острови',
        'ru_name': 'Бермудские острова',
        'en_name': 'Bermuda',
        'alpha_2': 'BM',
        'alpha_3': 'BMU',
    },
    'bhutan': {
        'uk_name': 'Бутан',
        'ru_name': 'Бутан',
        'en_name': 'Bhutan',
        'alpha_2': 'BT',
        'alpha_3': 'BTN',
    },
    'bolivia': {
        'uk_name': 'Болівія',
        'ru_name': 'Боливия',
        'en_name': 'Bolivia',
        'alpha_2': 'BO',
        'alpha_3': 'BOL',
    },
    'bonaire': {
        'uk_name': 'Карибські Нідерланди',
        'ru_name': 'Бонайре',
        'en_name': 'Bonaire',
        'alpha_2': 'BQ',
        'alpha_3': 'BES',
    },
    'botswana': {
        'uk_name': 'Ботсвана',
        'ru_name': 'Ботсвана',
        'en_name': 'Botswana',
        'alpha_2': 'BW',
        'alpha_3': 'BWA',
    },
    'brazil': {
        'uk_name': 'Бразилія',
        'ru_name': 'Бразилия',
        'en_name': 'Brazil',
        'alpha_2': 'BR',
        'alpha_3': 'BRA',
    },
    'britishindianoceanterritory': {
        'uk_name': 'Британська Територія в Індійському Океані',
        'ru_name': 'Британская Территория В Индийском Океане',
        'en_name': 'British Indian Ocean Territory',
        'alpha_2': 'IO',
        'alpha_3': 'IOT',
    },
    'britishvirginislands': {
        'uk_name': 'Британські Віргінські Острови',
        'ru_name': 'Британские Виргинские Острова',
        'en_name': 'British Virgin Islands',
        'alpha_2': 'VG',
        'alpha_3': 'VGB',
    },
    'brunei': {
        'uk_name': 'Бруней',
        'ru_name': 'Бруней',
        'en_name': 'Brunei',
        'alpha_2': 'BN',
        'alpha_3': 'BRN',
    },
    'bulgaria': {
        'uk_name': 'Болгарія',
        'ru_name': 'Болгария',
        'en_name': 'Bulgaria',
        'alpha_2': 'BG',
        'alpha_3': 'BGR',
    },
    'burkinafaso': {
        'uk_name': 'Буркіна-Фасо',
        'ru_name': 'Буркина-Фасо',
        'en_name': 'Burkina Faso',
        'alpha_2': 'BF',
        'alpha_3': 'BFA',
    },
    'burundi': {
        'uk_name': 'Бурунді',
        'ru_name': 'Бурунди',
        'en_name': 'Burundi',
        'alpha_2': 'BI',
        'alpha_3': 'BDI',
    },
    'cambodia': {
        'uk_name': 'Камбоджа',
        'ru_name': 'Камбоджа',
        'en_name': 'Cambodia',
        'alpha_2': 'KH',
        'alpha_3': 'KHM',
    },
    'cameroon': {
        'uk_name': 'Камерун',
        'ru_name': 'Камерун',
        'en_name': 'Cameroon',
        'alpha_2': 'CM',
        'alpha_3': 'CMR',
    },
    'canada': {
        'uk_name': 'Канада',
        'ru_name': 'Канада',
        'en_name': 'Canada',
        'alpha_2': 'CA',
        'alpha_3': 'CAN',
    },
    'capeverde': {
        'uk_name': 'Кабо-Верде',
        'ru_name': 'Кабо-Верде',
        'en_name': 'Cape Verde',
        'alpha_2': 'CV',
        'alpha_3': 'CPV',
    },
    'caymanislands': {
        'uk_name': 'Кайманові Острови',
        'ru_name': 'Каймановы Острова',
        'en_name': 'Cayman Islands',
        'alpha_2': 'KY',
        'alpha_3': 'CYM',
    },
    'centralafricanrepublic': {
        'uk_name': 'Центральноафриканська Республіка',
        'ru_name': 'Центральноафриканская Республика',
        'en_name': 'Central African Republic',
        'alpha_2': 'CF',
        'alpha_3': 'CAF',
    },
    'chad': {
        'uk_name': 'Чад',
        'ru_name': 'Чад',
        'en_name': 'Chad',
        'alpha_2': 'TD',
        'alpha_3': 'TCD',
    },
    'chile': {
        'uk_name': 'Чилі',
        'ru_name': 'Чили',
        'en_name': 'Chile',
        'alpha_2': 'CL',
        'alpha_3': 'CHL',
    },
    'china': {
        'uk_name': 'Китайська Народна Республіка',
        'ru_name': 'Китай',
        'en_name': 'China',
        'alpha_2': 'CN',
        'alpha_3': 'CHN',
    },
    'christmasisland': {
        'uk_name': 'Острів Різдва',
        'ru_name': 'Остров Рождества',
        'en_name': 'Christmas Island',
        'alpha_2': 'CX',
        'alpha_3': 'CXR',
    },
    'cocos(keeling)islands': {
        'uk_name': 'Кокосові острови',
        'ru_name': 'Кокосовые (Килинг Острова',
        'en_name': 'Cocos (Keeling) Islands',
        'alpha_2': 'CC',
        'alpha_3': 'CCK',
    },
    'colombia': {
        'uk_name': 'Колумбія',
        'ru_name': 'Колумбия',
        'en_name': 'Colombia',
        'alpha_2': 'CO',
        'alpha_3': 'COL',
    },
    'comoros': {
        'uk_name': 'Коморські Острови',
        'ru_name': 'Коморские острова',
        'en_name': 'Comoros',
        'alpha_2': 'KM',
        'alpha_3': 'COM',
    },
    'republicofthecongo': {
        'uk_name': 'Республіка Конго',
        'ru_name': 'Республика Конго',
        'en_name': 'Republic of the Congo',
        'alpha_2': 'CG',
        'alpha_3': 'COG',
    },
    'democraticrepublicofthecongo': {
        'uk_name': 'ДР Конго',
        'ru_name': 'Демократическая Республика Конго',
        'en_name': 'Democratic Republic of the Congo',
        'alpha_2': 'CD',
        'alpha_3': 'COD',
    },
    'cookislands': {
        'uk_name': 'Острови Кука',
        'ru_name': 'Кука',
        'en_name': 'Cook Islands',
        'alpha_2': 'CK',
        'alpha_3': 'COK',
    },
    'costarica': {
        'uk_name': 'Коста-Рика',
        'ru_name': 'Коста-Рика',
        'en_name': 'Costa Rica',
        'alpha_2': 'CR',
        'alpha_3': 'CRI',
    },
    'croatia': {
        'uk_name': 'Хорватія',
        'ru_name': 'Хорватия',
        'en_name': 'Croatia',
        'alpha_2': 'HR',
        'alpha_3': 'HRV',
    },
    'cuba': {
        'uk_name': 'Куба',
        'ru_name': 'Куба',
        'en_name': 'Cuba',
        'alpha_2': 'CU',
        'alpha_3': 'CUB',
    },
    'curaçao': {
        'uk_name': 'Кюрасао',
        'ru_name': 'Кюрасао',
        'en_name': 'Curaçao',
        'alpha_2': 'CW',
        'alpha_3': 'CUW',
    },
    'cyprus': {
        'uk_name': 'Кіпр',
        'ru_name': 'Кипр',
        'en_name': 'Cyprus',
        'alpha_2': 'CY',
        'alpha_3': 'CYP',
    },
    'czechrepublic': {
        'uk_name': 'Чехія',
        'ru_name': 'Чехия',
        'en_name': 'Czech Republic',
        'alpha_2': 'CZ',
        'alpha_3': 'CZE',
    },
    'denmark': {
        'uk_name': 'Данія',
        'ru_name': 'Дания',
        'en_name': 'Denmark',
        'alpha_2': 'DK',
        'alpha_3': 'DNK',
    },
    'djibouti': {
        'uk_name': 'Джибуті',
        'ru_name': 'Джибути',
        'en_name': 'Djibouti',
        'alpha_2': 'DJ',
        'alpha_3': 'DJI',
    },
    'dominica': {
        'uk_name': 'Домініка',
        'ru_name': 'Доминика',
        'en_name': 'Dominica',
        'alpha_2': 'DM',
        'alpha_3': 'DMA',
    },
    'dominicanrepublic': {
        'uk_name': 'Домініканська Республіка',
        'ru_name': 'Доминиканская Республика',
        'en_name': 'Dominican Republic',
        'alpha_2': 'DO',
        'alpha_3': 'DOM',
    },
    'ecuador': {
        'uk_name': 'Еквадор',
        'ru_name': 'Эквадор',
        'en_name': 'Ecuador',
        'alpha_2': 'EC',
        'alpha_3': 'ECU',
    },
    'egypt': {
        'uk_name': 'Єгипет',
        'ru_name': 'Египет',
        'en_name': 'Egypt',
        'alpha_2': 'EG',
        'alpha_3': 'EGY',
    },
    'elsalvador': {
        'uk_name': 'Сальвадор',
        'ru_name': 'Сальвадор',
        'en_name': 'El Salvador',
        'alpha_2': 'SV',
        'alpha_3': 'SLV',
    },
    'equatorialguinea': {
        'uk_name': 'Екваторіальна Гвінея',
        'ru_name': 'Экваториальная Гвинея',
        'en_name': 'Equatorial Guinea',
        'alpha_2': 'GQ',
        'alpha_3': 'GNQ',
    },
    'eritrea': {
        'uk_name': 'Еритрея',
        'ru_name': 'Эритрея',
        'en_name': 'Eritrea',
        'alpha_2': 'ER',
        'alpha_3': 'ERI',
    },
    'estonia': {
        'uk_name': 'Естонія',
        'ru_name': 'Эстония',
        'en_name': 'Estonia',
        'alpha_2': 'EE',
        'alpha_3': 'EST',
    },
    'ethiopia': {
        'uk_name': 'Ефіопія',
        'ru_name': 'Эфиопия',
        'en_name': 'Ethiopia',
        'alpha_2': 'ET',
        'alpha_3': 'ETH',
    },
    'falklandislands': {
        'uk_name': 'Фолклендські Острови',
        'ru_name': 'Фолклендские Острова',
        'en_name': 'Falkland Islands',
        'alpha_2': 'FK',
        'alpha_3': 'FLK',
    },
    'faroeislands': {
        'uk_name': 'Фарерські острови',
        'ru_name': 'Фарерские Острова',
        'en_name': 'Faroe Islands',
        'alpha_2': 'FO',
        'alpha_3': 'FRO',
    },
    'fiji': {
        'uk_name': 'Фіджі',
        'ru_name': 'Фиджи',
        'en_name': 'Fiji',
        'alpha_2': 'FJ',
        'alpha_3': 'FJI',
    },
    'finland': {
        'uk_name': 'Фінляндія',
        'ru_name': 'Финляндия',
        'en_name': 'Finland',
        'alpha_2': 'FI',
        'alpha_3': 'FIN',
    },
    'france': {
        'uk_name': 'Франція',
        'ru_name': 'Франция',
        'en_name': 'France',
        'alpha_2': 'FR',
        'alpha_3': 'FRA',
    },
    'frenchguiana': {
        'uk_name': 'Французька Гвіана',
        'ru_name': 'Французская Гвиана',
        'en_name': 'French Guiana',
        'alpha_2': 'GF',
        'alpha_3': 'GUF',
    },
    'frenchpolynesia': {
        'uk_name': 'Французька Полінезія',
        'ru_name': 'Французская Полинезия',
        'en_name': 'French Polynesia',
        'alpha_2': 'PF',
        'alpha_3': 'PYF',
    },
    'frenchsouthernandantarcticlands': {
        'uk_name': 'Французькі Південні і Антарктичні Території',
        'ru_name': 'Французские Южные и Антарктические территории',
        'en_name': 'French Southern and Antarctic Lands',
        'alpha_2': 'TF',
        'alpha_3': 'ATF',
    },
    'gabon': {
        'uk_name': 'Габон',
        'ru_name': 'Габон',
        'en_name': 'Gabon',
        'alpha_2': 'GA',
        'alpha_3': 'GAB',
    },
    'thegambia': {
        'uk_name': 'Гамбія',
        'ru_name': 'Гамбия',
        'en_name': 'The Gambia',
        'alpha_2': 'GM',
        'alpha_3': 'GMB',
    },
    'georgia': {
        'uk_name': 'Грузія',
        'ru_name': 'Грузия',
        'en_name': 'Georgia',
        'alpha_2': 'GE',
        'alpha_3': 'GEO',
    },
    'germany': {
        'uk_name': 'Німеччина',
        'ru_name': 'Германия',
        'en_name': 'Germany',
        'alpha_2': 'DE',
        'alpha_3': 'DEU',
    },
    'ghana': {
        'uk_name': 'Гана',
        'ru_name': 'Гана',
        'en_name': 'Ghana',
        'alpha_2': 'GH',
        'alpha_3': 'GHA',
    },
    'gibraltar': {
        'uk_name': 'Гібралтар',
        'ru_name': 'Гибралтар',
        'en_name': 'Gibraltar',
        'alpha_2': 'GI',
        'alpha_3': 'GIB',
    },
    'greece': {
        'uk_name': 'Греція',
        'ru_name': 'Греция',
        'en_name': 'Greece',
        'alpha_2': 'GR',
        'alpha_3': 'GRC',
    },
    'greenland': {
        'uk_name': 'Гренландія',
        'ru_name': 'Гренландия',
        'en_name': 'Greenland',
        'alpha_2': 'GL',
        'alpha_3': 'GRL',
    },
    'grenada': {
        'uk_name': 'Гренада',
        'ru_name': 'Гренада',
        'en_name': 'Grenada',
        'alpha_2': 'GD',
        'alpha_3': 'GRD',
    },
    'guadeloupe': {
        'uk_name': 'Гваделупа',
        'ru_name': 'Гваделупа',
        'en_name': 'Guadeloupe',
        'alpha_2': 'GP',
        'alpha_3': 'GLP',
    },
    'guam': {
        'uk_name': 'Гуам',
        'ru_name': 'ГУАМ',
        'en_name': 'Guam',
        'alpha_2': 'GU',
        'alpha_3': 'GUM',
    },
    'guatemala': {
        'uk_name': 'Гватемала',
        'ru_name': 'Гватемала',
        'en_name': 'Guatemala',
        'alpha_2': 'GT',
        'alpha_3': 'GTM',
    },
    'guernsey': {
        'uk_name': 'Гернсі',
        'ru_name': 'Гернси',
        'en_name': 'Guernsey',
        'alpha_2': 'GG',
        'alpha_3': 'GGY',
    },
    'guinea': {
        'uk_name': 'Гвінея',
        'ru_name': 'Гвинея',
        'en_name': 'Guinea',
        'alpha_2': 'GN',
        'alpha_3': 'GIN',
    },
    'guineabissau': {
        'uk_name': 'Гвінея-Бісау',
        'ru_name': 'Гвинея-Бисау',
        'en_name': 'Guinea-Bissau',
        'alpha_2': 'GW',
        'alpha_3': 'GNB',
    },
    'guyana': {
        'uk_name': 'Гаяна',
        'ru_name': 'Гайана',
        'en_name': 'Guyana',
        'alpha_2': 'GY',
        'alpha_3': 'GUY',
    },
    'haiti': {
        'uk_name': 'Гаїті',
        'ru_name': 'Гаити',
        'en_name': 'Haiti',
        'alpha_2': 'HT',
        'alpha_3': 'HTI',
    },
    'honduras': {
        'uk_name': 'Гондурас',
        'ru_name': 'Гондурас',
        'en_name': 'Honduras',
        'alpha_2': 'HN',
        'alpha_3': 'HND',
    },
    'hongkong': {
        'uk_name': 'Гонконг',
        'ru_name': 'Гонконг',
        'en_name': 'Hong Kong',
        'alpha_2': 'HK',
        'alpha_3': 'HKG',
    },
    'hungary': {
        'uk_name': 'Угорщина',
        'ru_name': 'Венгрия',
        'en_name': 'Hungary',
        'alpha_2': 'HU',
        'alpha_3': 'HUN',
    },
    'iceland': {
        'uk_name': 'Ісландія',
        'ru_name': 'Исландия',
        'en_name': 'Iceland',
        'alpha_2': 'IS',
        'alpha_3': 'ISL',
    },
    'india': {
        'uk_name': 'Індія',
        'ru_name': 'Индия',
        'en_name': 'India',
        'alpha_2': 'IN',
        'alpha_3': 'IND',
    },
    'indonesia': {
        'uk_name': 'Індонезія',
        'ru_name': 'Индонезия',
        'en_name': 'Indonesia',
        'alpha_2': 'ID',
        'alpha_3': 'IDN',
    },
    'ivorycoast': {
        'uk_name': 'Кот-д\'Івуар',
        'ru_name': 'Кот Д\'Ивуар',
        'en_name': 'Ivory Coast',
        'alpha_2': 'CI',
        'alpha_3': 'CIV',
    },
    'iran': {
        'uk_name': 'Іран',
        'ru_name': 'Иран',
        'en_name': 'Iran',
        'alpha_2': 'IR',
        'alpha_3': 'IRN',
    },
    'iraq': {
        'uk_name': 'Ірак',
        'ru_name': 'Ирак',
        'en_name': 'Iraq',
        'alpha_2': 'IQ',
        'alpha_3': 'IRQ',
    },
    'republicofireland': {
        'uk_name': 'Ірландія',
        'ru_name': 'Ирландия',
        'en_name': 'Republic of Ireland',
        'alpha_2': 'IE',
        'alpha_3': 'IRL',
    },
    'isleofman': {
        'uk_name': 'Острів Мен',
        'ru_name': 'Остров Мэн',
        'en_name': 'Isle of Man',
        'alpha_2': 'IM',
        'alpha_3': 'IMN',
    },
    'israel': {
        'uk_name': 'Ізраїль',
        'ru_name': 'Израиль',
        'en_name': 'Israel',
        'alpha_2': 'IL',
        'alpha_3': 'ISR',
    },
    'italy': {
        'uk_name': 'Італія',
        'ru_name': 'Италия',
        'en_name': 'Italy',
        'alpha_2': 'IT',
        'alpha_3': 'ITA',
    },
    'jamaica': {
        'uk_name': 'Ямайка',
        'ru_name': 'Ямайка',
        'en_name': 'Jamaica',
        'alpha_2': 'JM',
        'alpha_3': 'JAM',
    },
    'japan': {
        'uk_name': 'Японія',
        'ru_name': 'Япония',
        'en_name': 'Japan',
        'alpha_2': 'JP',
        'alpha_3': 'JPN',
    },
    'jordan': {
        'uk_name': 'Йорданія',
        'ru_name': 'Иордания',
        'en_name': 'Jordan',
        'alpha_2': 'JO',
        'alpha_3': 'JOR',
    },
    'kazakhstan': {
        'uk_name': 'Казахстан',
        'ru_name': 'Казахстан',
        'en_name': 'Kazakhstan',
        'alpha_2': 'KZ',
        'alpha_3': 'KAZ',
    },
    'kenya': {
        'uk_name': 'Кенія',
        'ru_name': 'Кения',
        'en_name': 'Kenya',
        'alpha_2': 'KE',
        'alpha_3': 'KEN',
    },
    'kiribati': {
        'uk_name': 'Кірибаті',
        'ru_name': 'Кирибати',
        'en_name': 'Kiribati',
        'alpha_2': 'KI',
        'alpha_3': 'KIR',
    },
    'kuwait': {
        'uk_name': 'Кувейт',
        'ru_name': 'Кувейт',
        'en_name': 'Kuwait',
        'alpha_2': 'KW',
        'alpha_3': 'KWT',
    },
    'kyrgyzstan': {
        'uk_name': 'Киргизстан',
        'ru_name': 'Кыргызстан',
        'en_name': 'Kyrgyzstan',
        'alpha_2': 'KG',
        'alpha_3': 'KGZ',
    },
    'laos': {
        'uk_name': 'Лаос',
        'ru_name': 'Лаос',
        'en_name': 'Laos',
        'alpha_2': 'LA',
        'alpha_3': 'LAO',
    },
    'latvia': {
        'uk_name': 'Латвія',
        'ru_name': 'Латвия',
        'en_name': 'Latvia',
        'alpha_2': 'LV',
        'alpha_3': 'LVA',
    },
    'lebanon': {
        'uk_name': 'Ліван',
        'ru_name': 'Ливан',
        'en_name': 'Lebanon',
        'alpha_2': 'LB',
        'alpha_3': 'LBN',
    },
    'lesotho': {
        'uk_name': 'Лесото',
        'ru_name': 'Лесото',
        'en_name': 'Lesotho',
        'alpha_2': 'LS',
        'alpha_3': 'LSO',
    },
    'liberia': {
        'uk_name': 'Ліберія',
        'ru_name': 'Либерия',
        'en_name': 'Liberia',
        'alpha_2': 'LR',
        'alpha_3': 'LBR',
    },
    'libya': {
        'uk_name': 'Лівія',
        'ru_name': 'Ливия',
        'en_name': 'Libya',
        'alpha_2': 'LY',
        'alpha_3': 'LBY',
    },
    'liechtenstein': {
        'uk_name': 'Ліхтенштейн',
        'ru_name': 'Лихтенштейн',
        'en_name': 'Liechtenstein',
        'alpha_2': 'LI',
        'alpha_3': 'LIE',
    },
    'lithuania': {
        'uk_name': 'Литва',
        'ru_name': 'Литва',
        'en_name': 'Lithuania',
        'alpha_2': 'LT',
        'alpha_3': 'LTU',
    },
    'luxembourg': {
        'uk_name': 'Люксембург',
        'ru_name': 'Люксембург',
        'en_name': 'Luxembourg',
        'alpha_2': 'LU',
        'alpha_3': 'LUX',
    },
    'republicofmacedonia': {
        'uk_name': 'Північна Македонія',
        'ru_name': 'Республика Македония',
        'en_name': 'Republic of Macedonia',
        'alpha_2': 'MK',
        'alpha_3': 'MKD',
    },
    'madagascar': {
        'uk_name': 'Мадагаскар',
        'ru_name': 'Мадагаскар',
        'en_name': 'Madagascar',
        'alpha_2': 'MG',
        'alpha_3': 'MDG',
    },
    'malawi': {
        'uk_name': 'Малаві',
        'ru_name': 'Малави',
        'en_name': 'Malawi',
        'alpha_2': 'MW',
        'alpha_3': 'MWI',
    },
    'malaysia': {
        'uk_name': 'Малайзія',
        'ru_name': 'Малайзия',
        'en_name': 'Malaysia',
        'alpha_2': 'MY',
        'alpha_3': 'MYS',
    },
    'maldives': {
        'uk_name': 'Мальдіви',
        'ru_name': 'Мальдивы',
        'en_name': 'Maldives',
        'alpha_2': 'MV',
        'alpha_3': 'MDV',
    },
    'mali': {
        'uk_name': 'Малі',
        'ru_name': 'Мали',
        'en_name': 'Mali',
        'alpha_2': 'ML',
        'alpha_3': 'MLI',
    },
    'malta': {
        'uk_name': 'Мальта',
        'ru_name': 'Мальта',
        'en_name': 'Malta',
        'alpha_2': 'MT',
        'alpha_3': 'MLT',
    },
    'marshallislands': {
        'uk_name': 'Маршаллові Острови',
        'ru_name': 'Маршалловы Острова',
        'en_name': 'Marshall Islands',
        'alpha_2': 'MH',
        'alpha_3': 'MHL',
    },
    'martinique': {
        'uk_name': 'Мартиніка',
        'ru_name': 'Мартиника',
        'en_name': 'Martinique',
        'alpha_2': 'MQ',
        'alpha_3': 'MTQ',
    },
    'mauritania': {
        'uk_name': 'Мавританія',
        'ru_name': 'Мавритания',
        'en_name': 'Mauritania',
        'alpha_2': 'MR',
        'alpha_3': 'MRT',
    },
    'mauritius': {
        'uk_name': 'Маврикій',
        'ru_name': 'Маврикий',
        'en_name': 'Mauritius',
        'alpha_2': 'MU',
        'alpha_3': 'MUS',
    },
    'mayotte': {
        'uk_name': 'Майотта',
        'ru_name': 'Майотта',
        'en_name': 'Mayotte',
        'alpha_2': 'YT',
        'alpha_3': 'MYT',
    },
    'mexico': {
        'uk_name': 'Мексика',
        'ru_name': 'Мексика',
        'en_name': 'Mexico',
        'alpha_2': 'MX',
        'alpha_3': 'MEX',
    },
    'federatedstatesofmicronesia': {
        'uk_name': 'Федеративні Штати Мікронезії',
        'ru_name': 'Федеративные Штаты Микронезии',
        'en_name': 'Federated States of Micronesia',
        'alpha_2': 'FM',
        'alpha_3': 'FSM',
    },
    'moldova': {
        'uk_name': 'Молдова',
        'ru_name': 'Молдова',
        'en_name': 'Moldova',
        'alpha_2': 'MD',
        'alpha_3': 'MDA',
    },
    'monaco': {
        'uk_name': 'Монако',
        'ru_name': 'Монако',
        'en_name': 'Monaco',
        'alpha_2': 'MC',
        'alpha_3': 'MCO',
    },
    'mongolia': {
        'uk_name': 'Монголія',
        'ru_name': 'Монголия',
        'en_name': 'Mongolia',
        'alpha_2': 'MN',
        'alpha_3': 'MNG',
    },
    'montenegro': {
        'uk_name': 'Чорногорія',
        'ru_name': 'Черногория',
        'en_name': 'Montenegro',
        'alpha_2': 'ME',
        'alpha_3': 'MNE',
    },
    'montserrat': {
        'uk_name': 'Монтсеррат',
        'ru_name': 'Монсеррат',
        'en_name': 'Montserrat',
        'alpha_2': 'MS',
        'alpha_3': 'MSR',
    },
    'morocco': {
        'uk_name': 'Марокко',
        'ru_name': 'Марокко',
        'en_name': 'Morocco',
        'alpha_2': 'MA',
        'alpha_3': 'MAR',
    },
    'mozambique': {
        'uk_name': 'Мозамбік',
        'ru_name': 'Мозамбик',
        'en_name': 'Mozambique',
        'alpha_2': 'MZ',
        'alpha_3': 'MOZ',
    },
    'myanmar': {
        'uk_name': 'М\'янма',
        'ru_name': 'Мьянма',
        'en_name': 'Myanmar',
        'alpha_2': 'MM',
        'alpha_3': 'MMR',
    },
    'namibia': {
        'uk_name': 'Намібія',
        'ru_name': 'Намибия',
        'en_name': 'Namibia',
        'alpha_2': 'NA',
        'alpha_3': 'NAM',
    },
    'nauru': {
        'uk_name': 'Науру',
        'ru_name': 'Науру',
        'en_name': 'Nauru',
        'alpha_2': 'NR',
        'alpha_3': 'NRU',
    },
    'nepal': {
        'uk_name': 'Непал',
        'ru_name': 'Непал',
        'en_name': 'Nepal',
        'alpha_2': 'NP',
        'alpha_3': 'NPL',
    },
    'netherlands': {
        'uk_name': 'Нідерланди',
        'ru_name': 'Нидерланды',
        'en_name': 'Netherlands',
        'alpha_2': 'NL',
        'alpha_3': 'NLD',
    },
    'newcaledonia': {
        'uk_name': 'Нова Каледонія',
        'ru_name': 'Новая Каледония',
        'en_name': 'New Caledonia',
        'alpha_2': 'NC',
        'alpha_3': 'NCL',
    },
    'newzealand': {
        'uk_name': 'Нова Зеландія',
        'ru_name': 'Новая Зеландия',
        'en_name': 'New Zealand',
        'alpha_2': 'NZ',
        'alpha_3': 'NZL',
    },
    'nicaragua': {
        'uk_name': 'Нікарагуа',
        'ru_name': 'Никарагуа',
        'en_name': 'Nicaragua',
        'alpha_2': 'NI',
        'alpha_3': 'NIC',
    },
    'niger': {
        'uk_name': 'Нігер',
        'ru_name': 'Нигер',
        'en_name': 'Niger',
        'alpha_2': 'NE',
        'alpha_3': 'NER',
    },
    'nigeria': {
        'uk_name': 'Нігерія',
        'ru_name': 'Нигерия',
        'en_name': 'Nigeria',
        'alpha_2': 'NG',
        'alpha_3': 'NGA',
    },
    'niue': {
        'uk_name': 'Ніуе',
        'ru_name': 'Ниуэ',
        'en_name': 'Niue',
        'alpha_2': 'NU',
        'alpha_3': 'NIU',
    },
    'norfolkisland': {
        'uk_name': 'Острів Норфолк',
        'ru_name': 'Остров Норфолк',
        'en_name': 'Norfolk Island',
        'alpha_2': 'NF',
        'alpha_3': 'NFK',
    },
    'northkorea': {
        'uk_name': 'Північна Корея',
        'ru_name': 'Северная Корея',
        'en_name': 'North Korea',
        'alpha_2': 'KP',
        'alpha_3': 'PRK',
    },
    'northernmarianaislands': {
        'uk_name': 'Північні Маріанські Острови',
        'ru_name': 'Северные Марианские Острова',
        'en_name': 'Northern Mariana Islands',
        'alpha_2': 'MP',
        'alpha_3': 'MNP',
    },
    'norway': {
        'uk_name': 'Норвегія',
        'ru_name': 'Норвегия',
        'en_name': 'Norway',
        'alpha_2': 'NO',
        'alpha_3': 'NOR',
    },
    'oman': {
        'uk_name': 'Оман',
        'ru_name': 'Оман',
        'en_name': 'Oman',
        'alpha_2': 'OM',
        'alpha_3': 'OMN',
    },
    'pakistan': {
        'uk_name': 'Пакистан',
        'ru_name': 'Пакистан',
        'en_name': 'Pakistan',
        'alpha_2': 'PK',
        'alpha_3': 'PAK',
    },
    'palau': {
        'uk_name': 'Палау',
        'ru_name': 'Палау',
        'en_name': 'Palau',
        'alpha_2': 'PW',
        'alpha_3': 'PLW',
    },
    'palestine': {
        'uk_name': 'Палестина',
        'ru_name': 'Палестина',
        'en_name': 'Palestine',
        'alpha_2': 'PS',
        'alpha_3': 'PSE',
    },
    'panama': {
        'uk_name': 'Панама',
        'ru_name': 'Панама',
        'en_name': 'Panama',
        'alpha_2': 'PA',
        'alpha_3': 'PAN',
    },
    'papuanewguinea': {
        'uk_name': 'Папуа Нова Гвінея',
        'ru_name': 'Папуа-Новая Гвинея',
        'en_name': 'Papua New Guinea',
        'alpha_2': 'PG',
        'alpha_3': 'PNG',
    },
    'paraguay': {
        'uk_name': 'Парагвай',
        'ru_name': 'Парагвай',
        'en_name': 'Paraguay',
        'alpha_2': 'PY',
        'alpha_3': 'PRY',
    },
    'peru': {
        'uk_name': 'Перу',
        'ru_name': 'Перу',
        'en_name': 'Peru',
        'alpha_2': 'PE',
        'alpha_3': 'PER',
    },
    'philippines': {
        'uk_name': 'Філіппіни',
        'ru_name': 'Филиппины',
        'en_name': 'Philippines',
        'alpha_2': 'PH',
        'alpha_3': 'PHL',
    },
    'pitcairnislands': {
        'uk_name': 'Піткерн',
        'ru_name': 'Острова Питкэрн',
        'en_name': 'Pitcairn Islands',
        'alpha_2': 'PN',
        'alpha_3': 'PCN',
    },
    'poland': {
        'uk_name': 'Польща',
        'ru_name': 'Польша',
        'en_name': 'Poland',
        'alpha_2': 'PL',
        'alpha_3': 'POL',
    },
    'portugal': {
        'uk_name': 'Португалія',
        'ru_name': 'Португалия',
        'en_name': 'Portugal',
        'alpha_2': 'PT',
        'alpha_3': 'PRT',
    },
    'puertorico': {
        'uk_name': 'Пуерто-Рико',
        'ru_name': 'Пуэрто-Рико',
        'en_name': 'Puerto Rico',
        'alpha_2': 'PR',
        'alpha_3': 'PRI',
    },
    'qatar': {
        'uk_name': 'Катар',
        'ru_name': 'Катар',
        'en_name': 'Qatar',
        'alpha_2': 'QA',
        'alpha_3': 'QAT',
    },
    'republicofkosovo': {
        'uk_name': 'Республіка Косово',
        'ru_name': 'Республика Косово',
        'en_name': 'Republic of Kosovo',
        'alpha_2': 'XK',
        'alpha_3': 'KOS',
    },
    'réunion': {
        'uk_name': 'Реюньйон',
        'ru_name': 'Реюньон',
        'en_name': 'Réunion',
        'alpha_2': 'RE',
        'alpha_3': 'REU',
    },
    'romania': {
        'uk_name': 'Румунія',
        'ru_name': 'Румыния',
        'en_name': 'Romania',
        'alpha_2': 'RO',
        'alpha_3': 'ROU',
    },
    'russia': {
        'uk_name': 'Росія',
        'ru_name': 'Россия',
        'en_name': 'Russia',
        'alpha_2': 'RU',
        'alpha_3': 'RUS',
    },
    'rwanda': {
        'uk_name': 'Руанда',
        'ru_name': 'Руанда',
        'en_name': 'Rwanda',
        'alpha_2': 'RW',
        'alpha_3': 'RWA',
    },
    'saintbarthélemy': {
        'uk_name': 'Сен-Бартелемі',
        'ru_name': 'Сен-Бартельми',
        'en_name': 'Saint Barthélemy',
        'alpha_2': 'BL',
        'alpha_3': 'BLM',
    },
    'saintkittsandnevis': {
        'uk_name': 'Сент-Кіттс і Невіс',
        'ru_name': 'Сент-Китс и Невис',
        'en_name': 'Saint Kitts and Nevis',
        'alpha_2': 'KN',
        'alpha_3': 'KNA',
    },
    'saintlucia': {
        'uk_name': 'Сент-Люсія',
        'ru_name': 'Сент-Люсия',
        'en_name': 'Saint Lucia',
        'alpha_2': 'LC',
        'alpha_3': 'LCA',
    },
    'saintmartin': {
        'uk_name': 'Сен-Мартен',
        'ru_name': 'Сен-Мартен',
        'en_name': 'Saint Martin',
        'alpha_2': 'MF',
        'alpha_3': 'MAF',
    },
    'saintpierreandmiquelon': {
        'uk_name': 'Сен-П\'єр і Мікелон',
        'ru_name': 'Сен-Пьер и Микелон',
        'en_name': 'Saint Pierre and Miquelon',
        'alpha_2': 'PM',
        'alpha_3': 'SPM',
    },
    'saintvincentandthegrenadines': {
        'uk_name': 'Сент-Вінсент і Гренадини',
        'ru_name': 'Сент-Винсент и Гренадины',
        'en_name': 'Saint Vincent and the Grenadines',
        'alpha_2': 'VC',
        'alpha_3': 'VCT',
    },
    'samoa': {
        'uk_name': 'Самоа',
        'ru_name': 'Самоа',
        'en_name': 'Samoa',
        'alpha_2': 'WS',
        'alpha_3': 'WSM',
    },
    'sanmarino': {
        'uk_name': 'Сан-Марино',
        'ru_name': 'Сан-Марино',
        'en_name': 'San Marino',
        'alpha_2': 'SM',
        'alpha_3': 'SMR',
    },
    'sãotoméandpríncipe': {
        'uk_name': 'Сан-Томе і Принсіпі',
        'ru_name': 'Сан-Томе и Принсипи',
        'en_name': 'São Tomé and Príncipe',
        'alpha_2': 'ST',
        'alpha_3': 'STP',
    },
    'saudiarabia': {
        'uk_name': 'Саудівська Аравія',
        'ru_name': 'Саудовская Аравия',
        'en_name': 'Saudi Arabia',
        'alpha_2': 'SA',
        'alpha_3': 'SAU',
    },
    'senegal': {
        'uk_name': 'Сенегал',
        'ru_name': 'Сенегал',
        'en_name': 'Senegal',
        'alpha_2': 'SN',
        'alpha_3': 'SEN',
    },
    'serbia': {
        'uk_name': 'Сербія',
        'ru_name': 'Сербия',
        'en_name': 'Serbia',
        'alpha_2': 'RS',
        'alpha_3': 'SRB',
    },
    'seychelles': {
        'uk_name': 'Сейшельські Острови',
        'ru_name': 'Сейшельские острова',
        'en_name': 'Seychelles',
        'alpha_2': 'SC',
        'alpha_3': 'SYC',
    },
    'sierraleone': {
        'uk_name': 'Сьєрра-Леоне',
        'ru_name': 'Сьерра-Леоне',
        'en_name': 'Sierra Leone',
        'alpha_2': 'SL',
        'alpha_3': 'SLE',
    },
    'singapore': {
        'uk_name': 'Сінгапур',
        'ru_name': 'Сингапур',
        'en_name': 'Singapore',
        'alpha_2': 'SG',
        'alpha_3': 'SGP',
    },
    'sintmaarten': {
        'uk_name': 'Сінт-Мартен',
        'ru_name': 'Синт-Мартен',
        'en_name': 'Sint Maarten',
        'alpha_2': 'SX',
        'alpha_3': 'SXM',
    },
    'slovakia': {
        'uk_name': 'Словаччина',
        'ru_name': 'Словакия',
        'en_name': 'Slovakia',
        'alpha_2': 'SK',
        'alpha_3': 'SVK',
    },
    'slovenia': {
        'uk_name': 'Словенія',
        'ru_name': 'Словения',
        'en_name': 'Slovenia',
        'alpha_2': 'SI',
        'alpha_3': 'SVN',
    },
    'solomonislands': {
        'uk_name': 'Соломонові Острови',
        'ru_name': 'Соломоновы Острова',
        'en_name': 'Solomon Islands',
        'alpha_2': 'SB',
        'alpha_3': 'SLB',
    },
    'somalia': {
        'uk_name': 'Сомалі',
        'ru_name': 'Сомали',
        'en_name': 'Somalia',
        'alpha_2': 'SO',
        'alpha_3': 'SOM',
    },
    'southafrica': {
        'uk_name': 'ПАР',
        'ru_name': 'Южная Африка',
        'en_name': 'South Africa',
        'alpha_2': 'ZA',
        'alpha_3': 'ZAF',
    },
    'southgeorgia': {
        'uk_name': 'Південна Джорджія та Південні Сандвічеві Острови',
        'ru_name': 'Южная Георгия',
        'en_name': 'South Georgia',
        'alpha_2': 'GS',
        'alpha_3': 'SGS',
    },
    'southkorea': {
        'uk_name': 'Південна Корея',
        'ru_name': 'Южная Корея',
        'en_name': 'South Korea',
        'alpha_2': 'KR',
        'alpha_3': 'KOR',
    },
    'southsudan': {
        'uk_name': 'Південний Судан',
        'ru_name': 'Южный Судан',
        'en_name': 'South Sudan',
        'alpha_2': 'SS',
        'alpha_3': 'SSD',
    },
    'spain': {
        'uk_name': 'Іспанія',
        'ru_name': 'Испания',
        'en_name': 'Spain',
        'alpha_2': 'ES',
        'alpha_3': 'ESP',
    },
    'srilanka': {
        'uk_name': 'Шрі-Ланка',
        'ru_name': 'Шри-Ланка',
        'en_name': 'Sri Lanka',
        'alpha_2': 'LK',
        'alpha_3': 'LKA',
    },
    'sudan': {
        'uk_name': 'Судан',
        'ru_name': 'Судан',
        'en_name': 'Sudan',
        'alpha_2': 'SD',
        'alpha_3': 'SDN',
    },
    'suriname': {
        'uk_name': 'Суринам',
        'ru_name': 'Суринам',
        'en_name': 'Suriname',
        'alpha_2': 'SR',
        'alpha_3': 'SUR',
    },
    'svalbardandjanmayen': {
        'uk_name': 'Свальбард і Ян-Маєн',
        'ru_name': 'Шпицберген и Ян Майен',
        'en_name': 'Svalbard and Jan Mayen',
        'alpha_2': 'SJ',
        'alpha_3': 'SJM',
    },
    'swaziland': {
        'uk_name': 'Есватіні',
        'ru_name': 'Свазиленд',
        'en_name': 'Swaziland',
        'alpha_2': 'SZ',
        'alpha_3': 'SWZ',
    },
    'sweden': {
        'uk_name': 'Швеція',
        'ru_name': 'Швеция',
        'en_name': 'Sweden',
        'alpha_2': 'SE',
        'alpha_3': 'SWE',
    },
    'switzerland': {
        'uk_name': 'Швейцарія',
        'ru_name': 'Швейцария',
        'en_name': 'Switzerland',
        'alpha_2': 'CH',
        'alpha_3': 'CHE',
    },
    'syria': {
        'uk_name': 'Сирія',
        'ru_name': 'Сирия',
        'en_name': 'Syria',
        'alpha_2': 'SY',
        'alpha_3': 'SYR',
    },
    'taiwan': {
        'uk_name': 'Тайвань',
        'ru_name': 'Тайвань',
        'en_name': 'Taiwan',
        'alpha_2': 'TW',
        'alpha_3': 'TWN',
    },
    'tajikistan': {
        'uk_name': 'Таджикистан',
        'ru_name': 'Таджикистан',
        'en_name': 'Tajikistan',
        'alpha_2': 'TJ',
        'alpha_3': 'TJK',
    },
    'tanzania': {
        'uk_name': 'Танзанія',
        'ru_name': 'Танзания',
        'en_name': 'Tanzania',
        'alpha_2': 'TZ',
        'alpha_3': 'TZA',
    },
    'thailand': {
        'uk_name': 'Таїланд',
        'ru_name': 'Таиланд',
        'en_name': 'Thailand',
        'alpha_2': 'TH',
        'alpha_3': 'THA',
    },
    'easttimor': {
        'uk_name': 'Східний Тимор',
        'ru_name': 'Восточный Тимор',
        'en_name': 'East Timor',
        'alpha_2': 'TL',
        'alpha_3': 'TLS',
    },
    'togo': {
        'uk_name': 'Того',
        'ru_name': 'Того',
        'en_name': 'Togo',
        'alpha_2': 'TG',
        'alpha_3': 'TGO',
    },
    'tokelau': {
        'uk_name': 'Токелау',
        'ru_name': 'Токелау',
        'en_name': 'Tokelau',
        'alpha_2': 'TK',
        'alpha_3': 'TKL',
    },
    'tonga': {
        'uk_name': 'Тонга',
        'ru_name': 'Тонга',
        'en_name': 'Tonga',
        'alpha_2': 'TO',
        'alpha_3': 'TON',
    },
    'trinidadandtobago': {
        'uk_name': 'Тринідад і Тобаго',
        'ru_name': 'Тринидад и Тобаго',
        'en_name': 'Trinidad and Tobago',
        'alpha_2': 'TT',
        'alpha_3': 'TTO',
    },
    'tunisia': {
        'uk_name': 'Туніс',
        'ru_name': 'Тунис',
        'en_name': 'Tunisia',
        'alpha_2': 'TN',
        'alpha_3': 'TUN',
    },
    'turkey': {
        'uk_name': 'Туреччина',
        'ru_name': 'Турция',
        'en_name': 'Turkey',
        'alpha_2': 'TR',
        'alpha_3': 'TUR',
    },
    'turkmenistan': {
        'uk_name': 'Туркменістан',
        'ru_name': 'Туркменистан',
        'en_name': 'Turkmenistan',
        'alpha_2': 'TM',
        'alpha_3': 'TKM',
    },
    'turksandcaicosislands': {
        'uk_name': 'Острови Теркс і Кайкос',
        'ru_name': 'Теркс и Кайкос',
        'en_name': 'Turks and Caicos Islands',
        'alpha_2': 'TC',
        'alpha_3': 'TCA',
    },
    'tuvalu': {
        'uk_name': 'Тувалу',
        'ru_name': 'Тувалу',
        'en_name': 'Tuvalu',
        'alpha_2': 'TV',
        'alpha_3': 'TUV',
    },
    'uganda': {
        'uk_name': 'Уганда',
        'ru_name': 'Уганда',
        'en_name': 'Uganda',
        'alpha_2': 'UG',
        'alpha_3': 'UGA',
    },
    'ukraine': {
        'uk_name': 'Україна',
        'ru_name': 'Украина',
        'en_name': 'Ukraine',
        'alpha_2': 'UA',
        'alpha_3': 'UKR',
    },
    'unitedarabemirates': {
        'uk_name': 'ОАЕ',
        'ru_name': 'Объединенные Арабские Эмираты',
        'en_name': 'United Arab Emirates',
        'alpha_2': 'AE',
        'alpha_3': 'ARE',
    },
    'unitedkingdom': {
        'uk_name': 'Велика Британія',
        'ru_name': 'Соединенное Королевство',
        'en_name': 'United Kingdom',
        'alpha_2': 'GB',
        'alpha_3': 'GBR',
    },
    'unitedstates': {
        'uk_name': 'США',
        'ru_name': 'Соединенные Штаты',
        'en_name': 'United States',
        'alpha_2': 'US',
        'alpha_3': 'USA',
    },
    'uruguay': {
        'uk_name': 'Уругвай',
        'ru_name': 'Уругвай',
        'en_name': 'Uruguay',
        'alpha_2': 'UY',
        'alpha_3': 'URY',
    },
    'uzbekistan': {
        'uk_name': 'Узбекистан',
        'ru_name': 'Узбекистан',
        'en_name': 'Uzbekistan',
        'alpha_2': 'UZ',
        'alpha_3': 'UZB',
    },
    'vanuatu': {
        'uk_name': 'Вануату',
        'ru_name': 'Вануату',
        'en_name': 'Vanuatu',
        'alpha_2': 'VU',
        'alpha_3': 'VUT',
    },
    'venezuela': {
        'uk_name': 'Венесуела',
        'ru_name': 'Венесуэла',
        'en_name': 'Venezuela',
        'alpha_2': 'VE',
        'alpha_3': 'VEN',
    },
    'vietnam': {
        'uk_name': 'В\'єтнам',
        'ru_name': 'Вьетнам',
        'en_name': 'Vietnam',
        'alpha_2': 'VN',
        'alpha_3': 'VNM',
    },
    'wallisandfutuna': {
        'uk_name': 'Волліс і Футуна',
        'ru_name': 'Уоллис и Футуна',
        'en_name': 'Wallis and Futuna',
        'alpha_2': 'WF',
        'alpha_3': 'WLF',
    },
    'westernsahara': {
        'uk_name': 'Західна Сахара',
        'ru_name': 'Западная Сахара',
        'en_name': 'Western Sahara',
        'alpha_2': 'EH',
        'alpha_3': 'ESH',
    },
    'yemen': {
        'uk_name': 'Ємен',
        'ru_name': 'Йемен',
        'en_name': 'Yemen',
        'alpha_2': 'YE',
        'alpha_3': 'YEM',
    },
    'zambia': {
        'uk_name': 'Замбія',
        'ru_name': 'Замбия',
        'en_name': 'Zambia',
        'alpha_2': 'ZM',
        'alpha_3': 'ZMB',
    },
    'zimbabwe': {
        'uk_name': 'Зімбабве',
        'ru_name': 'Зимбабве',
        'en_name': 'Zimbabwe',
        'alpha_2': 'ZW',
        'alpha_3': 'ZWE',
    },
};
